import React from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { ComponentMeta, ComponentStory } from '@storybook/react'

import Typography from 'components/UI/Typography/Typography'

import typoArgs, { TypographyArgs } from './TypographyArgs'

export default {
  title: 'Typography',
  component: Typography.H6,
} as ComponentMeta<typeof Typography.H6>

const H6Template: ComponentStory<typeof Typography.H6> = (
  args: TypographyArgs,
) => <Typography.H6 {...args} />

const H6 = H6Template.bind({})
H6.args = typoArgs

H6.storyName = 'H6'

export { H6 }
